/* --tim: redid this without the jQuery, but looks like the button is never disabled? */

(function preventQuizDoubleClick() {
  document.getElementById('NextQuestion').addEventListener('click', function removeDisabled() {
    setTimeout(() => {
      this.classList.remove('disabled');
    }, 100);
  });
}());
